import React from 'react';
import './PageNotFound.scss';

export const PageNotFound = () => (<h1 className="title"> PAGE NOT FOUND </h1>);
